import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import LazyLoadImg from "../../../elements/images/LazyLoadImg";
import H3 from "../../../elements/titles/H3";
import CategoryDropdown from "../../../utils/dropdowns/CategoryDropdown";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import searchContext from "../../../../dataManager/context/searchContext";

const CategoryCard = ({ category }) => {
  //context variables
  const { currentAdmin } = useContext(currentAdminContext);
  const { addFilters } = useContext(searchContext);

  const navigate = useNavigate();

  function calculateStars(starsNumber) {
    const stars = [];
    for (let i = 0; i < starsNumber; i++) {
      stars.push(<AiFillStar key={i} color="#161F30" />);
    }
    for (let i = 0; i < 5 - starsNumber; i++) {
      stars.push(<AiOutlineStar key={i} color="#161F30" />);
    }
    return stars;
  }

  const handleClick = () => {
    //add the filter to the filters context
    addFilters(category.getName);

    //navigate to all the products
    navigate("/produits");
  };

  return (
    <article
      onClick={handleClick}
      className="relative cursor-pointer rounded-lg p-3 hover:shadow-2xl"
    >
      <div className="flex w-full justify-center">
        <LazyLoadImg
          img={category.getImage}
          alt={category.getName}
          classe="object-contain  w-full h-44"
        />
      </div>
      <div>
        <H3 classe="my-2">{category.getName}</H3>
        <div className="flex items-center space-x-0.5">
          {calculateStars(category.getStarsNumber)}
        </div>
      </div>

      {currentAdmin?.role === 1 && (
        <p className="w-18 tex-4xl absolute left-2 top-1 z-10 px-2 py-1 font-bold">
          <CategoryDropdown categoryId={category.getId} />
        </p>
      )}
    </article>
  );
};

export default CategoryCard;
